<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      渠道管理
    </p>

    <Form ref="formInline" :model="params" :rules="wmsFormValidate" inline>
      <div style="display: flex; justify-content: center">
        <FormItem label="" prop="wmsCode" inline>
          <Select
            v-model="wmsObj"
            placeholder="请输入仓库名称"
            filterable
            clearable
            :remote-method="handleCreate1"
            @on-select="handleCreate2"
            :loading="wmsCodeLoading"
            class="public-inp"
          >
            <Option
              v-for="(option, i) in wmsCodeList"
              :value="option.wmsCode"
              :key="i"
              >{{ option.wmsName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeStatus('formInline')"
            >确定</Button
          >
        </FormItem>
      </div>
    </Form>
  </Card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
      wmsFormValidate: {
        wmsCode: [
          {
            required: true,
            message: "请选择仓库",
            trigger: "blur",
          },
        ],
      },
      wmsCodeLoading: false,
      wmsCodeList: [],
      params: null,
      wmsObj: null,
    };
  },
  computed: {
    ...mapGetters({
      shopInfoQueryList: "warehouse/getWmsChannelList",
    }),
  },
  watch: {},
  created() {},
  methods: {
    handleCreate1(val) {
      let data = { name: val };
      this.wmsCodeLoading = true;
      this.$api.wareVagueSearch(data).then((res) => {
        this.wmsCodeLoading = false;
        if (res.code == "200") {
          this.wmsCodeList = res.data;
        }
      });
    },
    handleCreate2(code) {
      this.wmsCodeList.forEach((item) => {
        console.log(this.wmsCodeList);
        if (item.wmsCode == code) {
          this.params = item;
        }
      });
    },
    changeStatus(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$router.replace({
            path: "source",
            query: this.params
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/warehouseEntry.vue